export default function getNextPageUrlFromState(slice: any) {
  return (state: any) => {
    return state.getIn([slice, 'meta', 'next']);
  };
}
